"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NormalizeApiResponseException = NormalizeApiResponseException;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _lodash = _interopRequireDefault(require("lodash.size"));

var _config = _interopRequireDefault(require("./constants/config"));

var _utils = require("./_utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function NormalizeApiResponseException(response) {
  this.error = response;
  this.statusCode = response.status;
  this.statusText = response.statusText;
}
/**
 * Data Access Object for all crud methods using fetch
 */


var DataAccessObject = /*#__PURE__*/function () {
  /**
   * Constructor for DAO.
   * @access private
   * @param {Object} config - request configuration paramaters.
   */
  // GENERAL PROPERTIES SHARED BY ALL.
  // x-sharing-password: required when accessing a password protected public resource. Base64 encoded.
  function DataAccessObject(config) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, DataAccessObject);
    (0, _defineProperty2["default"])(this, "_apiKey", void 0);
    (0, _defineProperty2["default"])(this, "_apiVersion", void 0);
    (0, _defineProperty2["default"])(this, "_accessToken", void 0);
    (0, _defineProperty2["default"])(this, "_environment", void 0);
    (0, _defineProperty2["default"])(this, "_endpoint", void 0);
    (0, _defineProperty2["default"])(this, "_sharingPassword", void 0);
    (0, _defineProperty2["default"])(this, "_token", void 0);
    (0, _defineProperty2["default"])(this, "normalizeApiResponse", function (promise) {
      var success = function success(response) {
        if (!response.ok) {
          throw new NormalizeApiResponseException(response);
        }

        if (response.headers && response.headers.has('content-type') && response.headers.get('content-type').indexOf('application/json') >= 0) {
          var results = response.json();
          var etag = response.headers.get('etag'); // If there is a etag in header add it to response body.  

          return !etag ? results : results.then(function (json) {
            return _objectSpread(_objectSpread({}, json), {}, {
              etag: etag
            });
          });
        }

        return response;
      };

      return promise.then(success, function (response) {
        return response;
      });
    });
    (0, _defineProperty2["default"])(this, "deleteRequest", function (request) {
      var _request$params = request.params,
          params = _request$params === void 0 ? {} : _request$params,
          _request$url = request.url,
          url = _request$url === void 0 ? '' : _request$url;
      var requestObj = {
        body: JSON.stringify(params),
        headers: _this.getHeaders(),
        method: 'DELETE'
      };
      return _this.normalizeApiResponse((0, _isomorphicFetch["default"])(url, requestObj));
    });
    (0, _defineProperty2["default"])(this, "getRequest", function (request) {
      var headers = request.headers,
          headersOverride = request.headersOverride,
          _request$params2 = request.params,
          params = _request$params2 === void 0 ? {} : _request$params2,
          _request$url2 = request.url,
          url = _request$url2 === void 0 ? '' : _request$url2;
      var requestUrl = (0, _lodash["default"])(params) ? "".concat(url, "?").concat((0, _utils.buildParamUrl)(params)) : url;
      var requestObj = {
        headers: _this.getHeaders(headers, headersOverride),
        method: 'GET'
      };
      return _this.normalizeApiResponse((0, _isomorphicFetch["default"])(requestUrl, requestObj));
    });
    (0, _defineProperty2["default"])(this, "headRequest", function (request) {
      var headers = request.headers,
          headersOverride = request.headersOverride,
          _request$params3 = request.params,
          params = _request$params3 === void 0 ? {} : _request$params3,
          _request$url3 = request.url,
          url = _request$url3 === void 0 ? '' : _request$url3;
      var requestUrl = (0, _lodash["default"])(params) ? "".concat(url, "?").concat((0, _utils.buildParamUrl)(params)) : url;
      var requestObj = {
        headers: _this.getHeaders(headers, headersOverride),
        method: 'HEAD'
      };
      return _this.normalizeApiResponse((0, _isomorphicFetch["default"])(requestUrl, requestObj));
    });
    (0, _defineProperty2["default"])(this, "optionsRequest", function (request) {
      var headers = request.headers,
          _request$params4 = request.params,
          params = _request$params4 === void 0 ? {} : _request$params4,
          _request$url4 = request.url,
          url = _request$url4 === void 0 ? '' : _request$url4;
      var requestUrl = (0, _lodash["default"])(params) ? "".concat(url, "?").concat((0, _utils.buildParamUrl)(params)) : url;
      var requestObj = {
        body: JSON.stringify(params),
        headers: headers || _this.getHeaders(),
        method: 'OPTIONS'
      };
      return _this.normalizeApiResponse((0, _isomorphicFetch["default"])(requestUrl, requestObj));
    });
    (0, _defineProperty2["default"])(this, "patchRequest", function (request) {
      var headers = request.headers,
          _request$params5 = request.params,
          params = _request$params5 === void 0 ? {} : _request$params5,
          _request$url5 = request.url,
          url = _request$url5 === void 0 ? '' : _request$url5;
      var patchObj = {
        body: JSON.stringify(params),
        headers: headers || _this.getHeaders(),
        method: 'PATCH'
      };
      return _this.normalizeApiResponse((0, _isomorphicFetch["default"])(url, patchObj));
    });
    (0, _defineProperty2["default"])(this, "postRequest", function (request) {
      var headers = request.headers,
          _request$params6 = request.params,
          params = _request$params6 === void 0 ? {} : _request$params6,
          _request$url6 = request.url,
          url = _request$url6 === void 0 ? '' : _request$url6;
      var requestObj = {
        body: JSON.stringify(params),
        headers: headers || _this.getHeaders(),
        method: 'POST'
      };
      return _this.normalizeApiResponse((0, _isomorphicFetch["default"])(url, requestObj));
    });
    (0, _defineProperty2["default"])(this, "putRequest", function (request) {
      var _request$params7 = request.params,
          params = _request$params7 === void 0 ? {} : _request$params7,
          _request$url7 = request.url,
          url = _request$url7 === void 0 ? '' : _request$url7;
      var requestObj = {
        body: JSON.stringify(params),
        headers: _this.getHeaders(),
        method: 'PUT'
      };
      return _this.normalizeApiResponse((0, _isomorphicFetch["default"])(url, requestObj));
    });
    var apiKey = config.apiKey,
        accessToken = config.accessToken,
        _config$apiVersion = config.apiVersion,
        apiVersion = _config$apiVersion === void 0 ? 'V3' : _config$apiVersion,
        _config$environment = config.environment,
        environment = _config$environment === void 0 ? 'stage' : _config$environment,
        sharingPassword = config.sharingPassword,
        token = config.token;
    this._apiKey = apiKey;
    this._accessToken = accessToken;
    this._apiVersion = apiVersion;
    this._environment = environment;
    this._endpoint = _config["default"][environment]['INVITATIONS_SERVICE_ENDPOINT'].replace('{VERSION}', apiVersion.toLowerCase()); // x-sharing-password: required when accessing a password protected public resource. Base64 encoded.

    this._sharingPassword = sharingPassword;
    this._token = token;
  }
  /**
   * Get the api key
   * @return {String} The current api key
   */


  (0, _createClass2["default"])(DataAccessObject, [{
    key: "getHeaders",

    /**
     * configures the request headers
     * @param {Object} headers - extra hader values
     * @param {Boolean} override - if the headers should be overriden without the defaults
     * @returns {Object} - returns the request headers
     */
    value: function getHeaders(headers, override) {
      var apiKey = this.apiKey,
          token = this.token,
          accessToken = this.accessToken;
      var defaultHeaders = {
        'content-type': 'application/json',
        'x-api-key': apiKey
      };

      if (token) {
        defaultHeaders.authorization = typeof token === 'string' && token.indexOf('Bearer ') > -1 ? token : "Bearer ".concat(token);
      }

      if (accessToken) {
        defaultHeaders['X-Access-Token'] = accessToken;
      }

      if (headers) {
        // just send the user headers with out defaults
        if (override) {
          return headers;
        } // spread in extra header values and override


        return _objectSpread(_objectSpread({}, defaultHeaders), headers);
      }

      return defaultHeaders;
    }
    /**
     * @method normalizeApiResponse 
     * Normalizes an fetch response by parsing the request and returning it,
     * or catching the error and returning object with server code.
     * 
     * @param {Promise} - the fetch promise request
     * @returns {Promise} - parses the response.
     */

  }, {
    key: "apiKey",
    get: function get() {
      return this._apiKey;
    }
    /**
     * Set the api key
     * @param {String} apiKey - The new key.
     */
    ,
    set: function set(apiKey) {
      this._apiKey = apiKey;
    }
    /**
    * Get the access token
    * @return {String} The current access token
    */

  }, {
    key: "accessToken",
    get: function get() {
      return this._accessToken;
    }
    /**
     * Set the api key
     * @param {String} apiKey - The new access token.
     */
    ,
    set: function set(accessToken) {
      this._accessToken = accessToken;
    }
    /**
     * Get the api key
     * @return {String} The current api key
     */

  }, {
    key: "apiVersion",
    get: function get() {
      return this._apiVersion;
    }
    /**
     * Set the api key
     * @param {String} apiKey - The new key.
     */
    ,
    set: function set(apiVersion) {
      this._apiVersion = apiVersion;
    }
    /**
     * Get the endpoint
     * @return {String} The current endpoint
     */

  }, {
    key: "endpoint",
    get: function get() {
      return this._endpoint;
    }
    /**
     * Set the environment.
     * @param {String} environment - The new environment
     */
    ,
    set: function set(endpoint) {
      this._endpoint = endpoint;
    }
    /**
     * Get the environment
     * @return {String} The current environment
     */

  }, {
    key: "environment",
    get: function get() {
      return this._environment;
    }
    /**
     * Set the environment.
     * @param {String} environment - The new environment
     */
    ,
    set: function set(environment) {
      // If the value specified is not accepted, throw an error.
      if (!_config["default"][environment]) {
        throw new Error("Setting the environment to ".concat(environment, " is not accepted"));
      } // Set the environment variable


      this._environment = environment;
      this._endpoint = _config["default"][environment]['INVITATIONS_SERVICE_ENDPOINT'];
    }
    /**
     * Get the sharingPassword
     * @return {String} The current sharingPassword
     */

  }, {
    key: "sharingPassword",
    get: function get() {
      return this._sharingPassword;
    }
    /**
     * Set the authorization sharingPassword
     * @param {String} token - The new sharingPassword.
     */
    ,
    set: function set(password) {
      this._sharingPassword = password;
    }
    /**
     * Get the token
     * @return {string} The current token
     * @example <caption>Get the token</caption>
     */

  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
    /**
     * Set the authorization token
     * @param {String} token - The new token.
     */
    ,
    set: function set(token) {
      this._token = token;
    }
  }]);
  return DataAccessObject;
}();

exports["default"] = DataAccessObject;